import { BaseProxy } from "@/proxies/BaseProxy";

export class ActivityNoteProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `updateActivityNotes`,
      parameters,
    });
  }
}
